import { render, staticRenderFns } from "./MarketingTab.vue?vue&type=template&id=1e7b4e88&scoped=true"
import script from "./MarketingTab.vue?vue&type=script&lang=js"
export * from "./MarketingTab.vue?vue&type=script&lang=js"
import style0 from "./MarketingTab.vue?vue&type=style&index=0&id=1e7b4e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b4e88",
  null
  
)

export default component.exports